// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__36E3j","cell":"ColumnAccessor_cell__IDgPB","firstCellAccent":"ColumnAccessor_firstCellAccent__B11Jc"};